import React from "react";

import { Box } from "@mui/material";

import { TreeView } from "@/components/shared/TreeView";

import styles from "./TeamsIntegrationTreeView.module.scss";

interface ITeamsIntegrationTreeViewProps {}

export const TeamsIntegrationTreeView: React.FC<ITeamsIntegrationTreeViewProps> = () => {
  return (
    <Box gap={2} className={styles.container}>
      <Box display="flex" flexDirection="column" gap={1}>
        <span className={styles.title}>Selected files</span>
        <span className={styles.description}>Select an attachment to input details.</span>
      </Box>
      <TreeView showSelectAll showDivider />
    </Box>
  );
};
